/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React, { useState } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import {
  HelpOutline as HelpOutlineIcon,
  InfoOutlined as InfoOutlinedIcon,
  ArrowBackOutlined as ArrowBackOutlinedIcon,
  ExpandMoreOutlined as ExpandMoreIcon,
  ExpandLessOutlined as ExpandLessIcon,
} from '@material-ui/icons';
import { Box, IconButton, Typography, Icon } from '@material-ui/core';
import useStyles from './useStyles';

const Menu = ({ onMenuClick, goToWaitlistScreen }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const { labelsData } = useSelector(state => state);
  const labels = labelsData?.labels;

  const MainMenu = [
    {
      name: labels.TMS_MENU_LAYOUT_DESIGN,
      icon: 'dashboard_customize',
      type: 'layoutDesign',
      isExpandable: false,
      subMenu: [],
    },
    {
      name: labels.TMS_MENU_SENSORS,
      icon: 'sensors',
      type: 'sensors',
      isExpandable: true,
      subMenu: [
        {
          name: labels.TMS_MENU_TABLE_SENSOR,
          type: 'tableSensor',
        },
        {
          name: labels.TMS_MENU_NAMED_SENSOR,
          type: 'namedSensor',
        },
      ],
    },
    {
      name: labels.TMS_MENU_SYNC_CHECKS,
      icon: 'sync',
      type: 'syncChecks',
      isExpandable: false,
      subMenu: [],
    },
  ];

  const SupportMenu = [
    // { name: labels.TMS_MENU_SETTINGS, icon: SettingsOutlinedIcon, type: 'settings' },
    { name: labels.TMS_MENU_HELP, icon: 'help_outline', type: 'help' },
    { name: labels.TMS_MENU_ABOUT, icon: 'info', type: 'about' },
  ];

  const onExpand = (type) => {
    if (type === expanded && expanded !== null) { //hide sub menu
      setExpanded(null);
    } else { //show sub menu
      setExpanded(type);
    }
  };

  const handleMenuClick = menuType => {
    setActiveMenu(menuType);
    onMenuClick && onMenuClick(menuType);
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.backWrapper}>
        <IconButton onClick={goToWaitlistScreen}>
          <ArrowBackOutlinedIcon className={classes.backIcon} fontSize='medium' />
        </IconButton>
      </Box>
      <Box className={classes.wrapper1}>
        {MainMenu.map(mainMenu =>
          <Box key={mainMenu.type}>
            <Box
              className={cn(classes.row, { [classes.activeMenuBgColor]: activeMenu === mainMenu.type })}
              position={'relative'}
              onClick={() => mainMenu.isExpandable
                ? onExpand(mainMenu.type)
                : handleMenuClick(mainMenu.type)
              }
            >
              <Icon className={cn('material-icons-outlined', classes.menuIcon)} fontSize='small'>{mainMenu.icon}</Icon>
              <Typography variant='body2' className={classes.menuLabel}>{mainMenu.name}</Typography>
              {mainMenu.isExpandable && (
                expanded
                  ? <ExpandLessIcon fontSize={'small'} className={cn(classes.menuIcon, classes.expandIcon)} />
                  : <ExpandMoreIcon fontSize={'small'} className={cn(classes.menuIcon, classes.expandIcon)} />
              )}
            </Box>
            {(mainMenu.isExpandable && expanded === mainMenu.type) && (
              <SubMenu subMenus={mainMenu.subMenu} onClick={handleMenuClick} activeMenu={activeMenu} />
            )}
          </Box>
        )}
      </Box>
      <Box className={classes.wrapper2}>
        {SupportMenu.map(supportMenu =>
          <Box
            key={supportMenu.type}
            onClick={() => handleMenuClick(supportMenu.type)}
            className={cn(classes.row, { [classes.activeMenuBgColor]: activeMenu === supportMenu.type })}
          >
            <Icon className={cn('material-icons-outlined', classes.menuIcon)} fontSize='small'>{supportMenu.icon}</Icon>
            <Typography variant='body2' className={classes.menuLabel}>{supportMenu.name}</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Menu;

const SubMenu = ({ subMenus, onClick, activeMenu }) => {
  const classes = useStyles();
  return (
    <Box className={classes.subMenuBgColor} borderRadius={'4px'} pl={2}>
      {subMenus.map(sbMenu =>
        <Box
          key={sbMenu.type}
          onClick={() => onClick(sbMenu.type)}
          className={cn(classes.row, { [classes.activeMenuBgColor]: activeMenu === sbMenu.type })}
        >
          <Typography variant='body2' className={classes.menuLabel}>{sbMenu.name}</Typography>
        </Box>
      )}
    </Box>
  );
};
